<div class="sidebar-context px-3 position-relative">

  <!-- Label -->
  <!-- <p class="text-white text-uppercase mb-2 d-block fw-light text-xxs">Active Context</p> -->

  <!-- SELECTED ITEM CARD -->
  <div
    class="sidebar-context-card context-card border rounded-3 p-2 bg-white shadow-sm cursor-pointer"
    @click="toggle"
  >
    <div class="sidebar-context-card-inner d-flex align-items-start justify-content-between">
      <div class="sidebar-context-copy">
        <p class="mb-0 text-dark fw-bold text-xs mb-1">{{ main_label }}</p>
        <p class="mb-0 text-secondary text-xxs text-break">{{ sub_label }}</p>
      </div>
      <i class="sidebar-context-toggle flex-shrink-0 text-secondary" :class="open ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
    </div>
  </div>

  <!-- DROPDOWN PANEL -->
  <div
    v-if="open"
    class="sidebar-context-dropdown context-dropdown position-absolute bg-white border rounded-3 p-3 w-100 mt-2 shadow"
  >

    <!-- OPTIONAL TOP SECTION (slot) -->
    <slot name="top"></slot>

    <!-- LIST SCROLL SECTION -->
    <div class="dropdown-scroll overflow-auto pe-1">

      <div
        v-for="item in items"
        :key="item.id"
        class="sidebar-context-option px-2 py-2 rounded-3 d-flex justify-content-between align-items-center fw-semibold text-xs"
        :class="{
          'disabled-tile': !isSelectable(item),
          'live-tile': isSelectable(item)
        }"
        :style="{ cursor: isSelectable(item) ? 'pointer' : 'not-allowed' }"
        @click="isSelectable(item) ? select(item) : null"
      >

        <!-- Item Label -->
        <div class="sidebar-context-option-copy d-flex align-items-center gap-2">
          <!-- ICON (visible only when sidebar is collapsed) -->
          <i 
            v-if="$root.sidebar_collapsed || item.icon"
            :class="item.icon"
            class="dropdown-item-icon text-secondary"
          ></i>

          <!-- LABEL -->
          <small
            class="d-block fw-semibold mb-0"
            :class="isActive(item) ? 'text-warning' : 'text-dark'"
          >
            {{ formatLabel(item) }}
          </small>

        </div>


        <!-- Active Dot -->
        <span v-if="isActive(item)" class="active-dot rounded-circle shadow-none bg-warning"></span>
      </div>

    </div>
  </div>

</div>
